import {
  ONBOARDING_SCREEN_VIEW, EMAIL_OPT_IN, FAVORITES_DONE_CLICK,
  ONBOARDING_BUTTON_CHOICE_CLICK, CLOSE_BUTTON_CLICK, ACQUISITION_DONE_CLICK,
} from './types';

export const triggerOnboardingScreenViewed = (step, stepName, totalSteps, pageName) => ({
  type: ONBOARDING_SCREEN_VIEW,
  step,
  stepName,
  totalSteps,
  pageName,
});

export const triggerOnboardingEmailOptInClicked = (sequenceValue, optedIn) => ({
  type: EMAIL_OPT_IN,
  sequenceValue,
  optedIn,
});

export const triggerOnboardingFavoritesDoneClicked = (action, numFavorited) => ({
  type: FAVORITES_DONE_CLICK,
  action,
  numFavorited,
});

export const triggerOnboardingButtonChoiceClicked = (action, sequenceValue) => ({
  type: ONBOARDING_BUTTON_CHOICE_CLICK,
  sequenceValue,
  action,
});

export const triggerOnboardingCloseClicked = (step, totalSteps) => ({
  type: CLOSE_BUTTON_CLICK,
  step,
  totalSteps,
});

export const triggerOnboardingAcquisitionClicked = (action) => ({
  type: ACQUISITION_DONE_CLICK,
  action,
});
